import { useContext, useEffect, useMemo, useState } from 'react'
import { GameContext } from '../App'
import getDebtPerSecond from '../../../shared/common/tasks/get_dps'

export default function useDebtCalculation() {
	const gameContext = useContext(GameContext)
	if (!gameContext) throw new Error('No GameContext')

	const initialDebt = BigInt(gameContext.money) ?? 0n
	const [debt, setDebt] = useState(initialDebt)
	const [previousInitialDebt, setPreviousInitialDebt] = useState(initialDebt)

	const startRelativeTimestamp = useMemo(
		() => performance.now(),
		[gameContext.purchases]
	)

	if (previousInitialDebt !== initialDebt) {
		setPreviousInitialDebt(initialDebt)
		setDebt(initialDebt)
	}

	const debtPerSecond = useMemo(
		() => getDebtPerSecond(gameContext),
		[gameContext.purchases]
	)

	useEffect(() => {
		let animationFrameId: number

		const updateDebt = () => {
			const elapsed = performance.now() - startRelativeTimestamp
			const newDebt =
				initialDebt -
				BigInt((BigInt(Math.floor(elapsed)) * debtPerSecond) / 1000n)
			if (newDebt !== debt) setDebt(newDebt)
			animationFrameId = requestAnimationFrame(updateDebt)
		}

		animationFrameId = requestAnimationFrame(updateDebt)
		return () => cancelAnimationFrame(animationFrameId)
	}, [gameContext.purchases])

	return {
		debt,
		debtPerSecond,
		startRelativeTimestamp
	}
}
